/** Hands a Blob to the browser as a file download (an object URL on a temporary <a download>). */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke later: some browsers (iOS Safari) read the URL after click() returns.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
